import { render, staticRenderFns } from "./RegisterDisclaimer.vue?vue&type=template&id=4a9de01e&"
import script from "./RegisterDisclaimer.vue?vue&type=script&lang=js&"
export * from "./RegisterDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports